import React from "react";

import { provinces } from "@/data/provinces";

import Dropdown from "./Dropdown";

interface ProvinceSelectProps {
  onChange: (value: string) => void;
  name: string;
  placeholder?: string;
  required?: boolean;
  autocomplete?: boolean;
  value?: string;
}

const ProvinceSelect = ({
  onChange,
  name,
  placeholder = "Select a province",
  required = false,
  autocomplete = false,
  value,
}: ProvinceSelectProps) => {
  return (
    <Dropdown
      options={provinces}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      required={required}
      autocomplete={autocomplete ? "address-level1" : "off"}
      value={value}
    />
  );
};

export default ProvinceSelect;
